import { useCallback } from 'react';
import { disconnect, type DisconnectParameters } from '../actions/disconnect';
import { useContext } from '../context';
import { useMutation, type MutationOptions } from './useMutation';

type UseDisconnectParameters = MutationOptions<void, DisconnectParameters | void>;

export function useDisconnect(parameters?: UseDisconnectParameters) {
  const { config } = useContext();

  const mutationFn = useCallback(async (parameters?: DisconnectParameters | void) => {
    await disconnect(config, parameters ?? undefined);
  }, []);

  const { status, data, error, mutate, mutateAsync } = useMutation(mutationFn, parameters);

  return {
    status,
    data,
    error,
    disconnect: mutate,
    disconnectAsync: mutateAsync,
  };
}
